import { Alert, Button, Card, Form, Input, message } from 'antd';
import { Auth } from 'aws-amplify';
import get from 'lodash/get';
import { Component } from 'react';
import uuid from 'uuid/v4';
import {
	InputStyles,
	addCompanyLabel,
	inputContainer,
	titleStyle,
} from './superUserCardStyles.js';

class SuperUserCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			emailExists: false,
			serverError: false,
		};
		this.formRef = React.createRef();
	}

	handleSubmit = (values) => {
		const { addUser, users } = this.props;

		if (users.find((user) => user.email === values.email)) {
			this.setState({ emailExists: true });
		} else {
			this.setState({ emailExists: false });

			Auth.signUp({
				username: uuid(),
				password: values.password,
				attributes: {
					email: values.email,
				},
			})
				.then((data) => {
					addUser({
						input: {
							cognitoId: data.user.username,
							emailAddress: get(values, 'email', '').toLowerCase(),
							role: 'employee',
							departmentId: ' ',
							avatar: null,
							lastLogin: null,
							active: true,
						},
					}).then(() => {
						message.config({
							top: 40,
						});
						message.success('Superuser successfully created!', 2.5, () => {
							this.formRef.current.resetFields();
						});
					});
				})
				.catch((error) => {
					this.setState({ serverError: true });
					console.error(error);
				});
		}
	};

	handleSubmitFailed = (errorInfo) => {
		console.log('Failed:', errorInfo);
	};

	render() {
		const { emailExists, serverError } = this.state;

		return (
			<Card style={{ width: '45%', border: '0' }}>
				<div className={addCompanyLabel}>Add a New SuperUser</div>
				<Form
					ref={this.formRef}
					onFinish={this.handleSubmit}
					onFinishFailed={this.handleSubmitFailed}
					layout="vertical"
				>
					<Form.Item
						className={InputStyles}
						label={<label className={titleStyle}>Admin Email Address</label>}
						name="email"
						rules={[
							{
								required: true,
								message: 'Email address required',
							},
							{
								type: 'email',
								message: 'Please enter a valid email address',
							},
						]}
					>
						<Input className={inputContainer} />
					</Form.Item>

					<Form.Item
						className={InputStyles}
						label={<label className={titleStyle}>Password</label>}
						name="password"
						rules={[
							{
								required: true,
								message: 'Password required',
							},
						]}
					>
						<Input.Password className={inputContainer} />
					</Form.Item>

					{emailExists && (
						<Alert type="error" message="Email is already in use" />
					)}
					{serverError && <Alert type="error" message="Server error" />}

					<Form.Item style={{ float: 'right', marginTop: '10px' }}>
						<Button type="primary" htmlType="submit">
							Submit
						</Button>
					</Form.Item>
				</Form>
			</Card>
		);
	}
}

export default SuperUserCard;
